import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { IGqlBaseOptions } from 'src/app/shared/modules/graphql/interfaces';
import { ListPage } from 'src/app/shared/helpers/list-page.class';
import { IApiInvestigationMetricsFilter, IApiInvestigationMetricsRiskTypeConnection } from 'src/app/shared/modules/graphql/types/types';
import { GqlInvestigationMetricsRiskTypeService } from 'src/app/shared/modules/graphql/services/reports';

@Injectable()
export class InvestigationMetricsRiskTypeService {
  constructor(
    private reports: GqlInvestigationMetricsRiskTypeService
  ) { }

  public get(filters?: IApiInvestigationMetricsFilter[], options?: IGqlBaseOptions): Observable<IApiInvestigationMetricsRiskTypeConnection> {
    return this.reports.get(filters, options || new ListPage());
  }

}
